  <sw-dynamic-autocomplete

    [formControl]="control"

    [placeholder]="
      col.placeholder || ''
    "

    [api]="
      col.dataSource?.api || ''
    "

    [valueField]="
      col.dataSource?.valueField || 'id'
    "

    [labelField]="
      col.dataSource?.labelField || 'name'
    "
    [minLength]="
        col.dataSource?.minLength || 2
      "

    [displayLabel]="
      displayLabel
    "

    [dependsOn]="
      col?.dependsOn || []
    "

    [parentForm]="form">

  </sw-dynamic-autocomplete>

  <mat-error
    *ngIf="
      control?.invalid &&
      control?.touched
    ">

    {{ getError() }}

  </mat-error>